import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HubioLoginService } from '@hubio/hubio-login';
import { allowedPages, V11Page, V11Service } from '@core/pages/user-management/v11-admin';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public username: string;
  public userManagement: boolean;
  public pages: V11Page[];

  constructor(
    private authService: HubioLoginService,
    public router: Router,
    private v11: V11Service
  ) { }

  ngOnInit() {
    const currentUser = this.authService.getCurrentUserTokenDecoded();
    if (currentUser) {
      this.username = currentUser.email;
    }
    // v11's own groups decide, page by page; r8-admin alone opens none of them
    this.pages = allowedPages(this.authService.getUserGroups());
    // Only hosts that serve v11 at /v11 have its admin to frame
    if (this.pages.length) {
      this.v11.served().then(served => this.userManagement = served);
    }
  }

  logout() {
    this.authService.logout();
  }

  headerVisible(product) {
    const urlSplit = this.router.url.split(';');
    return (urlSplit[0].indexOf(product) != -1);
  }
}
